import React, { useContext, useEffect, useState } from "react";
import globalComp from "../../../../global/components";
import { ProductContext, CanvasContext, ModuleContext } from "../../provider";
import { InputProps } from "../../../../global/components/RadioBox";

interface ColorCombinationProps {
  number: number;
  radioGroupName: string;
}

function ColorCombination({
  number,
  radioGroupName,
}: ColorCombinationProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { productColorType, setProductColorType, productType } = useContext(
    ProductContext
  );
  const { setModuleInfo, moduleInfo } = useContext(ModuleContext);
  const { canvasRef } = useContext(CanvasContext);

  const [colorCombinations, setColorCombinations] = useState<
    InputProps[] | any
  >([]);
  const [isPresetLoaded, setIsPresetLoaded] = useState<boolean>(false);
  const [isDefaultSet, setIsDefaultSet] = useState<boolean>(false);

  useEffect(() => {
    if (productColorType) {
      setModuleInfo({
        ...moduleInfo,
        bgColor: productColorType.backgroundColor,
        textColor: productColorType.textColor,
      });
    }
    loadColors();
  }, [productColorType]);

  useEffect(() => {
    if (colorCombinations.length) {
      if (!isDefaultSet) {
        setProductColorType({
          backgroundColor: colorCombinations[0].color.backgroundColor,
          textColor: colorCombinations[0].color.textColor,
          name: colorCombinations[0].radioLabelStr,
        });
        setIsDefaultSet(true);
      }
    }
  }, [colorCombinations]);

  useEffect(() => {
    if (moduleInfo && moduleInfo.bgColor && canvasRef.current) {
      // kids, ape-maia, vintage background is edited at ImagesPresets_Prd
      if (
        productType !== "kids" &&
        productType !== "vintage" &&
        productType !== "ape-maia"
      ) {
        canvasRef.current.backgroundColor = moduleInfo.bgColor;
        canvasRef.current.renderAll();
      }
    }
  }, [moduleInfo, canvasRef]);

  function loadColors() {
    if (
      window.INITIAL_DATA.COLORS &&
      window.INITIAL_DATA.COLORS.length &&
      !isPresetLoaded
    ) {
      let tempColorCombination = [];
      window.INITIAL_DATA.COLORS.map((color) => {
        tempColorCombination.push({
          // console.log({
          radioLabelStr: color.preset_name,
          name: radioGroupName,
          id: `${color.preset_name}-${radioGroupName}`,
          checked:
            productColorType &&
            productColorType.name.toLowerCase() ==
              color.preset_name.toLowerCase(),
          onChange: () => {
            setProductColorType({
              backgroundColor: color.background_color,
              textColor: color.text_color,
              name: color.preset_name,
            });
          },
          color: {
            backgroundColor: color.background_color,
            textColor: color.text_color,
          },
        });
      });
      setColorCombinations(tempColorCombination);
    } else {
      loadFallbackColors();
    }
  }

  // fallback has 2 default combinations
  function loadFallbackColors() {
    let tempColorCombination = [];
    tempColorCombination.push(
      {
        radioLabelStr: t.white,
        name: radioGroupName,
        id: "white-color-preset-input",
        checked:
          productColorType && productColorType.name.toLowerCase() == "white",
        onChange: () =>
          setProductColorType({
            backgroundColor: "#FFFFFF",
            textColor: "#000000",
            name: "white",
          }),
        color: {
          backgroundColor: "#FFFFFF",
          textColor: "#000000",
        },
      },
      {
        radioLabelStr: t.black,
        name: radioGroupName,
        id: "black-color-preset-input",
        checked:
          productColorType && productColorType.name.toLowerCase() == "black",
        onChange: () =>
          setProductColorType({
            backgroundColor: "#000000",
            textColor: "#FFFFFF",
            name: "black",
          }),
        color: {
          backgroundColor: "#000000",
          textColor: "#FFFFFF",
        },
      }
    );
    setColorCombinations(tempColorCombination);
    setIsPresetLoaded(true);
  }

  return (
    <globalComp.RadioBox
      number={number}
      labelStr={t.select_color_combination}
      tooltipStr={t.select_color_combination_tooltip}
      type={"color"}
      extraCssClass={"pb-3"}
      inputs={colorCombinations}
    />
  );
}

export default ColorCombination;
